// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.latestReportBadge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(1, 111, 175, 0.18);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(228, 245, 255, 0.95));
  box-shadow: 0 10px 24px rgba(1, 111, 175, 0.14);
  color: #0b2a6b;
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.latestReportBadge:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(1, 111, 175, 0.2);
  border-color: rgba(1, 111, 175, 0.32);
}

.latestReportBadge:focus-visible {
  outline: 2px solid rgba(1, 111, 175, 0.45);
  outline-offset: 2px;
}

.latestReportBadgeIcon {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #016faf, #14a2d6);
  color: #ffffff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);
}

.latestReportBadgeBody {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.05;
}

.latestReportBadgeLabel {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.latestReportBadgeMeta {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  margin-top: 3px;
  font-size: 11px;
  font-weight: 700;
  color: rgba(11, 42, 107, 0.7);
}

.latestReportBadgeType {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.latestReportBadgeArrow {
  font-size: 16px;
  font-weight: 700;
  color: #016faf;
}

html[data-brand="house-helper"] .latestReportBadge {
  border-color: rgba(47, 125, 50, 0.2);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(237, 248, 231, 0.96));
  box-shadow: 0 10px 24px rgba(47, 125, 50, 0.14);
  color: #17351c;
}

html[data-brand="house-helper"] .latestReportBadge:hover {
  box-shadow: 0 14px 28px rgba(47, 125, 50, 0.2);
  border-color: rgba(47, 125, 50, 0.34);
}

html[data-brand="house-helper"] .latestReportBadge:focus-visible {
  outline-color: rgba(47, 125, 50, 0.45);
}

html[data-brand="house-helper"] .latestReportBadgeIcon {
  background: linear-gradient(135deg, #2f7d32, #7cc243);
}

html[data-brand="house-helper"] .latestReportBadgeMeta {
  color: rgba(23, 53, 28, 0.72);
}

html[data-brand="house-helper"] .latestReportBadgeArrow {
  color: #2f7d32;
}

@media (max-width: 768px) {
  .latestReportBadge {
    gap: 2px;
    padding: 7px 10px;
  }

  .latestReportBadgeIcon {
    width: 24px;
    height: 24px;
  }

  .latestReportBadgeLabel {
    font-size: 12px;
  }

  .latestReportBadgeMeta {
    font-size: 10px;
  }

  .latestReportBadgeType {
    max-width: 108px;
  }
}

@media (max-width: 540px) {
  .latestReportBadge {
   max-width: min(58vw, 220px);
        padding: 2px 2px;
        margin-right: 7px;
  }

  .latestReportBadgeMeta {
    display: none;
  }

  .latestReportBadgeLabel {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/LatestReportBadge.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,yFAAyF;EACzF,+CAA+C;EAC/C,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qDAAqD;EACrD,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yFAAyF;EACzF,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;GACC,2BAA2B;QACtB,gBAAgB;QAChB,iBAAiB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".latestReportBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(1, 111, 175, 0.18);\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(228, 245, 255, 0.95));\n  box-shadow: 0 10px 24px rgba(1, 111, 175, 0.14);\n  color: #0b2a6b;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.latestReportBadge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(1, 111, 175, 0.2);\n  border-color: rgba(1, 111, 175, 0.32);\n}\n\n.latestReportBadge:focus-visible {\n  outline: 2px solid rgba(1, 111, 175, 0.45);\n  outline-offset: 2px;\n}\n\n.latestReportBadgeIcon {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #016faf, #14a2d6);\n  color: #ffffff;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);\n}\n\n.latestReportBadgeBody {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  line-height: 1.05;\n}\n\n.latestReportBadgeLabel {\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.latestReportBadgeMeta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  margin-top: 3px;\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(11, 42, 107, 0.7);\n}\n\n.latestReportBadgeType {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.latestReportBadgeArrow {\n  font-size: 16px;\n  font-weight: 700;\n  color: #016faf;\n}\n\nhtml[data-brand=\"house-helper\"] .latestReportBadge {\n  border-color: rgba(47, 125, 50, 0.2);\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(237, 248, 231, 0.96));\n  box-shadow: 0 10px 24px rgba(47, 125, 50, 0.14);\n  color: #17351c;\n}\n\nhtml[data-brand=\"house-helper\"] .latestReportBadge:hover {\n  box-shadow: 0 14px 28px rgba(47, 125, 50, 0.2);\n  border-color: rgba(47, 125, 50, 0.34);\n}\n\nhtml[data-brand=\"house-helper\"] .latestReportBadge:focus-visible {\n  outline-color: rgba(47, 125, 50, 0.45);\n}\n\nhtml[data-brand=\"house-helper\"] .latestReportBadgeIcon {\n  background: linear-gradient(135deg, #2f7d32, #7cc243);\n}\n\nhtml[data-brand=\"house-helper\"] .latestReportBadgeMeta {\n  color: rgba(23, 53, 28, 0.72);\n}\n\nhtml[data-brand=\"house-helper\"] .latestReportBadgeArrow {\n  color: #2f7d32;\n}\n\n@media (max-width: 768px) {\n  .latestReportBadge {\n    gap: 2px;\n    padding: 7px 10px;\n  }\n\n  .latestReportBadgeIcon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .latestReportBadgeLabel {\n    font-size: 12px;\n  }\n\n  .latestReportBadgeMeta {\n    font-size: 10px;\n  }\n\n  .latestReportBadgeType {\n    max-width: 108px;\n  }\n}\n\n@media (max-width: 540px) {\n  .latestReportBadge {\n   max-width: min(58vw, 220px);\n        padding: 2px 2px;\n        margin-right: 7px;\n  }\n\n  .latestReportBadgeMeta {\n    display: none;\n  }\n\n  .latestReportBadgeLabel {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
